import axios from 'axios';
import { toast } from 'react-toastify';
import appConfig from '../config/app-config';

const { API_URL } = appConfig;

const api = axios.create({
  baseURL: API_URL,
  timeout: 300000,
});

const errorHandler = error => {
  const err = {
    error,
    code: 400,
    message: '',
  };

  if (error.response) {
    err.message =
      error.response.data.message ||
      error.response.data.error_description ||
      error.response.data.error;
    err.code = error.response.status;
    if (
      err.code === 401 &&
      window.location.pathname !== '/login' &&
      window.location.pathname !== '/cadastro' &&
      window.location.pathname !== '/esqueci-senha'
    ) {
      window.location.href = `/login?r=${encodeURIComponent(window.location.href)}`;
      window.localStorage.removeItem('user_token');
    } else if (err.code === 403) {
      toast.error('Você não tem permissão para realizar esta operação.');
    }
  } else if (error.request) {
    err.message = error.message;
  } else {
    err.code = 500;
    err.message = error.message;
    toast.error('Não foi possível processar a requisição. Erro 500.');
  }
  throw err;
};

export const errorsHandler = err => {
  if (typeof err.error.response.data.modelState !== 'undefined') {
    let error = 'Ocorreu o seguinte erro: ';

    const erros = err.error.response.data.modelState;
    for (const p in erros) {
      let name = p.replace('model.', '');
      name = name[0].toUpperCase() + name.slice(1);
      error += `${erros[p]}; `;
    }
    toast.warning(error.trim());
  } else {
    toast.error('Ocorreu um erro ao salvar os dados, tente novamente mais tarde');
  }
};

export const getDmService = url => {
  const token = localStorage.getItem('user_token');
  api.defaults.headers.common.Authorization = `Bearer ${token}`;
  return api
    .get(url)
    .then(res => res.data)
    .catch(errorHandler);
};

export const getByDmService = (url, id) => {
  const token = localStorage.getItem('user_token');
  api.defaults.headers.common.Authorization = `Bearer ${token}`;
  return api
    .get(`${url}/${id}`)
    .then(res => res.data)
    .catch(errorHandler);
};

export const updateDmService = (url, id, data) => {
  const token = localStorage.getItem('user_token');
  api.defaults.headers.common.Authorization = `Bearer ${token}`;
  return api
    .patch(`${url}/${id}`, data)
    .then(res => res.data)
    .catch(errorHandler);
};

export const pathDmService = (url, data) => {
  const token = localStorage.getItem('user_token');
  api.defaults.headers.common.Authorization = `Bearer ${token}`;
  return api
    .patch(url, data)
    .then(res => res.data)
    .catch(errorHandler);
};

export const insertDmService = (url, data) => {
  const token = localStorage.getItem('user_token');
  api.defaults.headers.common.Authorization = `Bearer ${token}`;
  return api
    .post(url, data)
    .then(res => res.data)
    .catch(errorHandler);
};

export const deleteDmService = (url, id) => {
  const token = localStorage.getItem('user_token');
  api.defaults.headers.common.Authorization = `Bearer ${token}`;
  return api
    .delete(`${url}/${id}`)
    .then(res => res.data)
    .catch(errorHandler);
};

export const reqToken = data =>
  axios
    .post(`${API_URL}/Token`, data)
    .then(res => res.data)
    .catch(errorHandler);

export const esqueciSenhaService = email =>
  axios
    .patch(`${API_URL}/Usuario/EsqueciSenha/?email=${email}`)
    .then(res => res.data)
    .catch(errorHandler);



// WEBPACK FOOTER //
// ./src/services/Api.js